import GeneralDialog from '../../../shared/general-dialog';
import { DriveSweepModel } from '../../../../types';
import DriveSweepLogsGrid from './drive-sweep-logs-grid';
import Stack from '@mui/material/Stack';

interface DriveSweepLogsDialogProps {
  open: boolean;
  handleClose: () => void;
  selectedDriveSweep: DriveSweepModel;
}

export default function DriveSweepLogsDialog({
  open,
  handleClose,
  selectedDriveSweep,
}: DriveSweepLogsDialogProps) {
  return (
    <GeneralDialog
      open={open}
      handleClose={handleClose}
      title="Drive Sweep Logs"
      maxWidth="md"
      dialogContent={
        <Stack gap={2} sx={{ pl: 2, pr: 2 }}>
          <DriveSweepLogsGrid
            folderId={selectedDriveSweep.folderId}
            height={500}
          />
        </Stack>
      }
      primaryButton={{
        loading: false,
        action: handleClose,
        disabled: false,
        title: 'Close',
      }}
    />
  );
}
